import makeCall from "../services/api";
import findItem from "../utils/findItem";
import getUpdatedCounts from "../utils/getUpdatedCounts";

export default {
  state: {
    page: 1,
    invoiceList: [],
    searchResults: {}
  },
  mutations: {
    clearInvoiceState(state) {
      state.page = 1
      state.invoiceList = []
      state.searchResults = {}
    },
    updateInvoiceList(state, list) {
      localStorage.setItem("invoiceList", JSON.stringify(list));
      state.invoiceList = list;
    },
    updateInvoicePage(state, page) {
      state.page = page;
    },
    updatedSearchResults(state, searchResults) {
      if (searchResults) {
        localStorage.setItem("searchResults", JSON.stringify(searchResults));
      }
      state.searchResults = searchResults || {};
    }
  },
  actions: {
    async loadSearchResults({ commit, state }, payload) {
      const { action, terms, page } = payload;
      const data = await makeCall(
        { url: `/search/${action}/${terms}/${page}/` },
        commit
      );

      let savedKeys = [];
      let lowestIndex = null;
      let lowestKey = null;
      let highestIndex = null;
      state.searchResults &&
        Object.keys(state.searchResults).map(i => {
          const index = state.searchResults[i].index;
          savedKeys.push(i);
          if (lowestIndex === null) {
            lowestIndex = index;
            lowestKey = i;
          } else {
            if (index < lowestIndex) {
              lowestIndex = index;
              lowestKey = i;
            }
          }
          highestIndex = highestIndex
            ? index > highestIndex
              ? index
              : highestIndex
            : index;
        });

      const compiledResult = payload.terms &&
        state.searchResults &&
        state.searchResults[payload.terms]
        ? {
            ...state.searchResults[payload.terms],
            page: page,
            results: [
              ...state.searchResults[payload.terms].results,
              ...data.invoiceList
            ]
          }
        : {
            results: data.invoiceList,
            page: page,
            index: highestIndex ? highestIndex + 1 : 1,
            hideSuggest: action === "filter",
            total: parseInt(data.total)
          };

      if (data && data.invoiceList) {
        let searchResults = {
          ...state.searchResults,
          [payload.terms]: compiledResult
        };
        if (savedKeys.length > 8) {
          delete searchResults[lowestKey];
        }
        commit("updatedSearchResults", searchResults);
      }
    },
    async deleteInvoice({ commit, state }, invoice) {
      const data = await makeCall(
        {
          url: "/invoices/" + invoice + "/",
          method: "delete"
        },
        commit
      );

      if (data && data.success) {
        // DELETE FROM MAIN LIST
        const { itemIndex, foundItem } = findItem(
          state.invoiceList,
          "invoice",
          invoice
        );
        let updatedList = [...state.invoiceList];
        updatedList.splice(itemIndex, 1);
        commit("updateInvoiceList", updatedList);
        commit(
          "updateCounts",
          getUpdatedCounts(this.getters.counts, foundItem, "subtract")
        );

        // DELETE FROM SEARCHED RESULTS
        const searchResults = {...state.searchResults}
        let updatedSearchResults = {}
        Object.keys(searchResults).map(key => {
          const sr = { 
            ...searchResults[key],
            total: searchResults[key].total - 1,
            results: [...searchResults[key].results].filter(r => r.invoice !== invoice)
          }
          return updatedSearchResults[key] = sr
        })
        commit("updatedSearchResults", updatedSearchResults)

      }
    },
    async loadMoreInvoices({ commit, state }) {
      const loadedPages = state.invoiceList.length / 10;
      const newPage = state.page + 1;
      if (newPage > loadedPages) {
        const data = await makeCall(
          {
            url: `/invoices/${newPage}/`
          },
          commit
        );
        commit("updateInvoiceList", [
          ...state.invoiceList,
          ...data.invoiceList
        ]);
      }

      commit("updateInvoicePage", newPage);
    },
    async submitInvoiceForm({ commit, state }, payload) {
      const formType = payload.formType;

      let newInvoice = { ...payload };
      delete newInvoice["formType"];

      try {
        const result = await makeCall(
          {
            url: `/invoices/${formType}/`,
            body: newInvoice,
            method: formType === "create" ? "POST" : "PATCH"
          },
          commit
        );

        if (result && result.success) {
          if (formType === "create") {
            commit("updateInvoiceList", [newInvoice, ...state.invoiceList]);
          }
          if (formType === "update") {
            // Update in main list
            const { itemIndex, foundItem } = findItem(
              state.invoiceList,
              "invoice",
              payload.invoice
            );
            commit(
              "updateCounts",
              getUpdatedCounts(this.getters.counts, foundItem, "subtract")
            );
            let updatedItem = { ...foundItem, ...newInvoice };
            let updatedInvoiceList = [...state.invoiceList];
            updatedInvoiceList[itemIndex] = updatedItem;
            commit("updateInvoiceList", updatedInvoiceList);

            // Update in search results
            const searchResults = {...state.searchResults}
            let updatedSearchResults = {}
            Object.keys(searchResults).map(key => {
              const sr = { 
                ...searchResults[key],
                total: searchResults[key].total - 1,
                results: [...searchResults[key].results].map(r => {
                  if (r.invoice !== payload.invoice) return r
                  else return { ...updatedItem }
                })
              }
              return updatedSearchResults[key] = sr
            })
            commit("updatedSearchResults", updatedSearchResults)
          }
          commit(
            "updateCounts",
            getUpdatedCounts(this.getters.counts, payload, "add")
          );
          return "success";
        } else {
          return "failed";
        }
      } catch (e) {
        return "failed";
      }
    }
  },
  getters: {
    invoiceList(state) {
      return state.invoiceList;
    },
    page(state) {
      return state.page;
    },
    searchResults(state) {
      return state.searchResults || {};
    },
    compiledSearchResults(state) {
      let res = [];
      Object.keys(state.searchResults).map(k => {
        res = [...res, ...state.searchResults[k].results];
      });
      return res;
    },
    recentSearches(state) {
      if (!state.searchResults) return []
      let res = [];
      Object.keys(state.searchResults).map(k => {
        if (!state.searchResults[k].hideSuggest) {
          res.push(k);
        }
      });
      return res;
    }
  }
};
